import React, { useEffect, useState } from 'react';
import { checkPermission } from '@/utils/permission';
import { Button, Col, Collapse, Row, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import TreatmentSessionForm from './TreatmentSessionForm';
import GeneralExamForm from '@/routes/customers/Detail/GeneralExam/GeneralExamForm';
import GeneralExamList from '@/routes/customers/Detail/GeneralExam/GeneralExamList';
import OrthodonticExamForm from '@/routes/customers/Detail/OrthodonticExam/OrthodonticExamForm';
import OrthodonticExamList from '@/routes/customers/Detail/OrthodonticExam/OrthodonticExamList';
import TreatmentSessionList from './TreatmentSessionList';
import PrintButton from '@/components/PrintButton/PrintButton';
import PrintTreatmentSessionForm from './PrintTreatmentSessionForm';
import { useDispatch, useSelector } from 'react-redux';
import { getListProcedure } from '@/redux/actions/procedureActions';
import PrintOrthodonticExamForm from '@/routes/customers/Detail/OrthodonticExam/PrintOrthodonticExamForm';
import PrintGeneralExamForm from '@/routes/customers/Detail/GeneralExam/PrintGeneralExamForm';
import TreatmentSessionCreateDirectForm from './TreatmentSessionCreateDirectForm';

const { Panel } = Collapse;

const TreatmentSessionIndex = ({ customer }) => {

    const dispatch = useDispatch();

    const customerId = customer?.id;

    const [isGeneralExamFormOpen, setIsGeneralExamFormOpen] = useState(false);
    const [isOrthodonticExamFormOpen, setIsOrthodonticExamFormOpen] = useState(false);
    const [isTreatmentSessionFormOpen, setIsTreatmentSessionFormOpen] = useState(false);
    const [isTreatmentSessionCreateDirectFormOpen, setIsTreatmentSessionCreateDirectFormOpen] = useState(false);

    const [treatmentCount, setTreatmentCount] = useState(0);
    const [orthoCount, setOrthoCount] = useState(0);
    const [generalCount, setGeneralCount] = useState(0);

    const procedureList = useSelector((s) => s.procedureReducer.procedureList) || [];
    const diseases = useSelector((state) => state.diseasesReducer.diseases_active_list);

    const loadProcedureList = async () => {
        try {
            await dispatch(getListProcedure({ status: 1, per_page: 1000 }));
        } finally {

        }
    };

    useEffect(() => {
        loadProcedureList();
    }, []);

    const renderHeader = (title, count) => (
        <span className="color-blue fw-medium">
            {title} ({count})
        </span>
    );

    const canCreateGeneralExam = checkPermission('general_exams', 'create');
    const canCreateOrthodonticExam = checkPermission('orthodontic_exams', 'create');
    const canCreateTreatmentSession = checkPermission('treatment_sessions', 'create');

    const openGeneralExamForm = () => setIsGeneralExamFormOpen(true);
    const closeGeneralExamForm = () => setIsGeneralExamFormOpen(false);

    const openOrthodonticExamForm = () => setIsOrthodonticExamFormOpen(true);
    const closeOrthodonticExamForm = () => setIsOrthodonticExamFormOpen(false);

    const openTreatmentSessionForm = () => setIsTreatmentSessionFormOpen(true);
    const closeTreatmentSessionForm = () => setIsTreatmentSessionFormOpen(false);

    const openTreatmentSessionCreateDirectForm = () => setIsTreatmentSessionCreateDirectFormOpen(true);
    const closeTreatmentSessionCreateDirectForm = () => setIsTreatmentSessionCreateDirectFormOpen(false);

    return (
        <div>
            <Row gutter={8} className="mt-4 mb-4">
                <Col span={24}>
                    <Space>
                        <Button
                            icon={<PlusOutlined />}
                            type="primary"
                            style={{ backgroundColor: "#722ed1", borderColor: "#722ed1" }}
                            onClick={openTreatmentSessionForm}
                            disabled={!canCreateTreatmentSession}
                        >
                            Thêm phiếu điều trị
                        </Button>
                        <Button
                            icon={<PlusOutlined />}
                            type="primary"
                            style={{ backgroundColor: "#cc7709", borderColor: "#e7870a" }}
                            onClick={openTreatmentSessionCreateDirectForm}
                            disabled={!canCreateTreatmentSession}
                        >
                            Thêm phiếu điều trị (không qua lịch hẹn)
                        </Button>
                        <Button
                            icon={<PlusOutlined />}
                            type="primary"
                            style={{ backgroundColor: "#52c41a", borderColor: "#4c8d2c" }}
                            onClick={openOrthodonticExamForm}
                            disabled={!canCreateOrthodonticExam}
                        >
                            Thêm phiếu khám chỉnh nha
                        </Button>
                        <Button
                            icon={<PlusOutlined />}
                            type="primary"
                            style={{ backgroundColor: "#1677ff", borderColor: "#1677ff" }}
                            onClick={openGeneralExamForm}
                            disabled={!canCreateGeneralExam}
                        >
                            Thêm phiếu khám tổng quát
                        </Button>
                    </Space>
                </Col>
                <Col span={24} className='mt-4'>
                    <Space>
                        <PrintButton printText="In phiếu điều trị" disabled={!procedureList?.length}>
                            <PrintTreatmentSessionForm customer={customer} data={procedureList} />
                        </PrintButton>
                        <PrintButton printText="In phiếu khám chỉnh nha">
                            <PrintOrthodonticExamForm customer={customer} />
                        </PrintButton>
                        <PrintButton printText="In phiếu khám tổng quát" disabled={!diseases?.length}>
                            <PrintGeneralExamForm customer={customer} diseases={diseases} />
                        </PrintButton>
                    </Space>
                </Col>
            </Row>

            <Collapse
                defaultActiveKey={[]}
                accordion={false}
                bordered={false}
                className="no-padding-collapse"
            >
                <Panel
                    header={renderHeader("PHIẾU ĐIỀU TRỊ", treatmentCount)}
                    forceRender
                    key="3"
                >
                    <TreatmentSessionList customer={customer} onCountChange={setTreatmentCount} />
                </Panel>
                <Panel
                    header={renderHeader("PHIẾU KHÁM CHỈNH NHA", orthoCount)}
                    forceRender
                    key="2"
                >
                    <OrthodonticExamList customer={customer} onCountChange={setOrthoCount} />
                </Panel>
                <Panel
                    header={renderHeader("PHIẾU KHÁM TỔNG QUÁT", generalCount)}
                    forceRender
                    key="1"
                >
                    <GeneralExamList customer={customer} onCountChange={setGeneralCount} />
                </Panel>
            </Collapse>

            <GeneralExamForm
                customer={customer}
                visible={isGeneralExamFormOpen}
                onCancel={closeGeneralExamForm}
            />

            <OrthodonticExamForm
                customer={customer}
                visible={isOrthodonticExamFormOpen}
                onCancel={closeOrthodonticExamForm}
            />

            <TreatmentSessionForm
                customer={customer}
                customerId={customerId}
                visible={isTreatmentSessionFormOpen}
                onCancel={closeTreatmentSessionForm}
            />

            <TreatmentSessionCreateDirectForm
                customer={customer}
                customerId={customerId}
                visible={isTreatmentSessionCreateDirectFormOpen}
                onCancel={closeTreatmentSessionCreateDirectForm}
            />
        </div>
    );
};

export default TreatmentSessionIndex;
